import { useRouteError } from "react-router-dom";

// The errorElement of the app's route. A data router catches the render
// errors of its routes and shows its own error page; the app did not have
// one (BrowserRouter): the error is thrown again, out of the router (an
// error boundary showing its fallback that throws passes the error up), as
// before.
export default function RethrowRouteError() {
  throw useRouteError();
}
